<template>
  <section id="cta">
    <div class="">
      <div class="z-10 text-center px-16 pb-16 pt-16 pb-3 bg-image-1">
        <h2 class="text-xl font-bold text-white sm:text-2xl md:text-3xl pb-4" data-aos="fade-up" data-aos-id-contact>
          お申し込みはこちら
        </h2>
        <a
          class="mx-auto flex mt-12 md:pl-16 p-4 bg-white hover:bg-gray-100 button"
          href="https://docs.google.com/forms/d/e/1FAIpQLSdsfnGJTNbHYE_Aa03F_tcHs17O0o68lAyo5AbBVtuHbJUkqw/viewform?usp=sf_link"
          target="_blank"
          data-aos="fade-up"
          data-aos-anchor="[data-aos-id-contact]"
          data-aos-delay="200"
        >
          <img class="w-3 mr-2" :src="require('@/images/arrow.svg')" />
          <span class="block font-bold text-theme-900">お申し込みフォームへ</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Cta",
  components: {},
  data: function() {
    return {}
  },
}
</script>

<style scoped>
.bg-image-1 {
  background-image: url("./../images/contact-background.jpg");
  background-size: cover;
  background-position: center;
}
</style>
